export default {
  filtersPlaceholder: 'Apply filters to find what you need',
  customizables: 'Customizable',
  vocals: 'Vocals',
  duration: {
    any: 'Any Duration',
    selected: '{{minValue}} to {{maxValue}}',
  },
  sortBy: {
    popular: 'Most Popular',
    recent: 'Most Recent',
  },
  mobile: {
    showFilters: 'Show Filters',
    clearFilters: 'Clear Filters',
    seeTracks: 'See Tracks',
    popular: 'Popular',
    recent: 'Recent',
  },
};
